import type { FC, ReactNode } from 'react';
import { Card, Flex, Typography } from 'antd';

const { Text } = Typography;

export type PenaltyBreakdownLine = {
  id: string;
  label: ReactNode;
  amount: string;
};

export interface PenaltyBreakdownCardProps {
  title: string;
  subtitle: string;
  amountLabel: string;
  amount: string;
  lines: PenaltyBreakdownLine[];
}

/** Penalty summary with recoverable/at-risk total and line breakdown. */
export const PenaltyBreakdownCard: FC<PenaltyBreakdownCardProps> = ({
  title,
  subtitle,
  amountLabel,
  amount,
  lines,
}) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={16}>
        <div>
          <Text className="ds-card-label">{title}</Text>
          <Text
            type="secondary"
            style={{ display: 'block', marginTop: 4, fontSize: 13 }}
          >
            {subtitle}
          </Text>
        </div>

        <div>
          <Text className="ds-small-label">{amountLabel}</Text>
          <Text
            className="ds-kpi-value om-kpi-card__metric"
            style={{ display: 'block', marginTop: 4 }}
          >
            {amount}
          </Text>
        </div>

        <div className="om-penalty-lines">
          {lines.map((line) => (
            <Flex
              key={line.id}
              justify="space-between"
              align="center"
              gap={12}
              className="om-penalty-line"
            >
              <Text className="om-penalty-line__label">{line.label}</Text>
              <Text strong className="om-penalty-line__amount">
                {line.amount}
              </Text>
            </Flex>
          ))}
        </div>
      </Flex>
    </Card>
  );
};
